// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BrandsSlide_brands__TmOvg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 16px;
}
.BrandsSlide_inner__Hkri8 {
  display: flex;
  justify-content: center;
  align-items: center;
  /* max-width: 500px; */
  width: 100%;
  position: relative;
  flex-direction: column;
  gap: 8px;
}
.BrandsSlide_items__TcYns {
  /* width: 330px; */
  width: 100%;
  display: flex;
  overflow: hidden;
  overflow-y: hidden;
  /* overflow-x: auto; */
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  flex-flow: nowrap;
}
.BrandsSlide_item__3nhQN {
  width: 100%;
}
.BrandsSlide_item__3nhQN img {
  width: 100%;
  /* max-width: unset; */
  /* min-width: 327px; */
  /* min-height: 146px; */
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 16px;
  overflow: hidden;
}
.BrandsSlide_title__6IGnb {
}
.BrandsSlide_title__6IGnb span {
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 450;
  line-height: 20px; /* 166.667% */
}
.BrandsSlide_brands-inner__LP5st {
  width: 100%;
}
.BrandsSlide_brands-title__-3ohr {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 3px;
  margin-bottom: 16px;
}
.BrandsSlide_brands-title__-3ohr span {
  color: #fff;
  text-align: right;
  /* font-family: "Ravi FaNum"; */
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.BrandsSlide_brands-title__-3ohr img {
}
.BrandsSlide_brands-items__5GY0Y {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: wrap;
  gap: 8px;
}
.BrandsSlide_brands-item__txmo4 {
  width: 48%;
  border-radius: 0px 0px 0px 16px;
  border-right: 4px solid #fef1c5;
  background: rgba(254, 241, 197, 0.08);
  height: 45px;
  padding: 10px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* min-width: 156px; */
  /* min-height: 40px; */
}

.BrandsSlide_brands-item__txmo4 img {
  /* max-width: 105px; */
  /* max-height: 39px; */
  /* object-fit: contain; */
}
@media screen and (min-width: 1000px) {
  .BrandsSlide_inner__Hkri8 {
    max-width: 398px;
  }
  .BrandsSlide_items__TcYns {
    width: 398px;
  }
  .BrandsSlide_title__6IGnb span {
    font-size: 18px;
  }
  .BrandsSlide_brands-title__-3ohr span {
    font-size: 16px;
  }
  .BrandsSlide_brands-item__txmo4 {
    width: 49%;
    min-height: 45px;
  }
  .BrandsSlide_item__3nhQN img {
    width: 100%;
    max-width: unset;
    min-width: 398px;
    min-height: 180px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/brands/BrandsSlider/BrandsSlide.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;AACA;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;AACA;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;AACA;EACE,UAAU;EACV,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".brands {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 16px;\n}\n.inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* max-width: 500px; */\n  width: 100%;\n  position: relative;\n  flex-direction: column;\n  gap: 8px;\n}\n.items {\n  /* width: 330px; */\n  width: 100%;\n  display: flex;\n  overflow: hidden;\n  overflow-y: hidden;\n  /* overflow-x: auto; */\n  justify-content: flex-start;\n  align-items: center;\n  gap: 16px;\n  flex-flow: nowrap;\n}\n.item {\n  width: 100%;\n}\n.item img {\n  width: 100%;\n  /* max-width: unset; */\n  /* min-width: 327px; */\n  /* min-height: 146px; */\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  border-radius: 16px;\n  overflow: hidden;\n}\n.title {\n}\n.title span {\n  color: #fff;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 20px; /* 166.667% */\n}\n.brands-inner {\n  width: 100%;\n}\n.brands-title {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 3px;\n  margin-bottom: 16px;\n}\n.brands-title span {\n  color: #fff;\n  text-align: right;\n  /* font-family: \"Ravi FaNum\"; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.brands-title img {\n}\n.brands-items {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-flow: wrap;\n  gap: 8px;\n}\n.brands-item {\n  width: 48%;\n  border-radius: 0px 0px 0px 16px;\n  border-right: 4px solid #fef1c5;\n  background: rgba(254, 241, 197, 0.08);\n  height: 45px;\n  padding: 10px 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* min-width: 156px; */\n  /* min-height: 40px; */\n}\n\n.brands-item img {\n  /* max-width: 105px; */\n  /* max-height: 39px; */\n  /* object-fit: contain; */\n}\n@media screen and (min-width: 1000px) {\n  .inner {\n    max-width: 398px;\n  }\n  .items {\n    width: 398px;\n  }\n  .title span {\n    font-size: 18px;\n  }\n  .brands-title span {\n    font-size: 16px;\n  }\n  .brands-item {\n    width: 49%;\n    min-height: 45px;\n  }\n  .item img {\n    width: 100%;\n    max-width: unset;\n    min-width: 398px;\n    min-height: 180px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brands": `BrandsSlide_brands__TmOvg`,
	"inner": `BrandsSlide_inner__Hkri8`,
	"items": `BrandsSlide_items__TcYns`,
	"item": `BrandsSlide_item__3nhQN`,
	"title": `BrandsSlide_title__6IGnb`,
	"brands-inner": `BrandsSlide_brands-inner__LP5st`,
	"brands-title": `BrandsSlide_brands-title__-3ohr`,
	"brands-items": `BrandsSlide_brands-items__5GY0Y`,
	"brands-item": `BrandsSlide_brands-item__txmo4`
};
export default ___CSS_LOADER_EXPORT___;
